module.exports = __webpack_public_path__ + "img/chatcaptain-logo.1d9f04fe.svg";